import { render, staticRenderFns } from "./AccountApplicationCommunication.vue?vue&type=template&id=f6c69aac&scoped=true&"
import script from "./AccountApplicationCommunication.vue?vue&type=script&lang=ts&"
export * from "./AccountApplicationCommunication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c69aac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6c69aac')) {
      api.createRecord('f6c69aac', component.options)
    } else {
      api.reload('f6c69aac', component.options)
    }
    module.hot.accept("./AccountApplicationCommunication.vue?vue&type=template&id=f6c69aac&scoped=true&", function () {
      api.rerender('f6c69aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountApplication/accountApplicationCommunication/AccountApplicationCommunication.vue"
export default component.exports